module.exports = __webpack_public_path__ + "buyIntegral.png?e22a0827f323eed66ecab18a111522a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buyIntegral.png
// module id = 14
// module chunks = 0